import { accountHomeViewConstants } from "../_constants";
import { accountHomeViewService } from "../_services";
import { alertActions } from "./";
import { SubmissionError } from 'redux-form';

export const accountHomeViewActions = {
  getAppliances,
  getAppliance,
  setAppliance,
  getHolidayMode,
  setHolidayMode,
  getDoNotDisturb,
  setDoNotDisturb,
  getTariff,
  setTariff,
};

function getAppliances(user) {
  return (dispatch) => {
    dispatch(request());

    accountHomeViewService.getAppliances(user).then(
      (detail) => {
        dispatch(success(detail));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: accountHomeViewConstants.APPLIANCES_REQUEST };
  }
  function success(detail) {
    return { type: accountHomeViewConstants.APPLIANCES_SUCCESS, detail };
  }
  function failure(error) {
    return { type: accountHomeViewConstants.APPLIANCES_FAILURE, error };
  }
}

function getAppliance(user, id) {
  return (dispatch) => {
    dispatch(request());

    accountHomeViewService.getAppliance(user, id).then(
      (detail) => {
        dispatch(success(detail));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: accountHomeViewConstants.GET_APPLIANCE_REQUEST };
  }
  function success(detail) {
    return { type: accountHomeViewConstants.GET_APPLIANCE_SUCCESS, detail };
  }
  function failure(error) {
    return { type: accountHomeViewConstants.GET_APPLIANCE_FAILURE, error };
  }
}
function setAppliance(user_id, values) {
  return (dispatch) => {
    dispatch(request());

    accountHomeViewService.setAppliance(user_id, values).then(
      (detail) => {
        dispatch(success(detail));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: accountHomeViewConstants.SET_APPLIANCE_REQUEST };
  }
  function success(detail) {
    return { type: accountHomeViewConstants.SET_APPLIANCE_SUCCESS, detail };
  }
  function failure(error) {
    return { type: accountHomeViewConstants.SET_APPLIANCE_FAILURE, error };
  }
}

function getHolidayMode(user) {
  return (dispatch) => {
    dispatch(request());

    accountHomeViewService.getHolidayMode(user).then(
      (detail) => {
        dispatch(success(detail));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: accountHomeViewConstants.GET_HOLIDAY_MODE_REQUEST };
  }
  function success(detail) {
    return { type: accountHomeViewConstants.GET_HOLIDAY_MODE_SUCCESS, detail };
  }
  function failure(error) {
    return { type: accountHomeViewConstants.GET_HOLIDAY_MODE_FAILURE, error };
  }
}
function setHolidayMode(user_id, values) {
  return (dispatch) => {
    dispatch(request());

    accountHomeViewService.setHolidayMode(user_id, values).then(
      (detail) => {
        dispatch(success(detail));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: accountHomeViewConstants.SET_HOLIDAY_MODE_REQUEST };
  }
  function success(detail) {
    return { type: accountHomeViewConstants.SET_HOLIDAY_MODE_SUCCESS, detail };
  }
  function failure(error) {
    return { type: accountHomeViewConstants.SET_HOLIDAY_MODE_FAILURE, error };
  }
}
function getDoNotDisturb(user) {
  return (dispatch) => {
    dispatch(request());

    accountHomeViewService.getDoNotDisturb(user).then(
      (detail) => {
        dispatch(success(detail));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: accountHomeViewConstants.GET_DO_NOT_DISTURB_REQUEST };
  }
  function success(detail) {
    return {
      type: accountHomeViewConstants.GET_DO_NOT_DISTURB_SUCCESS,
      detail,
    };
  }
  function failure(error) {
    return { type: accountHomeViewConstants.GET_DO_NOT_DISTURB_FAILURE, error };
  }
}
function setDoNotDisturb(user_id, values) {
  return (dispatch) => {
    dispatch(request());

    accountHomeViewService.setDoNotDisturb(user_id, values).then(
      (detail) => {
        dispatch(success(detail));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: accountHomeViewConstants.SET_DO_NOT_DISTURB_REQUEST };
  }
  function success(detail) {
    return {
      type: accountHomeViewConstants.SET_DO_NOT_DISTURB_SUCCESS,
      detail,
    };
  }
  function failure(error) {
    return { type: accountHomeViewConstants.SET_DO_NOT_DISTURB_FAILURE, error };
  }
}

function getTariff(user) {
  return (dispatch) => {
    dispatch(request());

    accountHomeViewService.getTariff(user).then(
      (detail) => {
        dispatch(success(detail));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: accountHomeViewConstants.GET_TARIFF_REQUEST };
  }
  function success(detail) {
    return { type: accountHomeViewConstants.GET_TARIFF_SUCCESS, detail };
  }
  function failure(error) {
    return { type: accountHomeViewConstants.GET_TARIFF_FAILURE, error };
  }
}

function setTariff(user_id, values) {
  return (dispatch) => {
    dispatch(request());

    return accountHomeViewService.setTariff(user_id, values).then(
      (detail) => {
        dispatch(success(detail));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));

        throw new SubmissionError({
          _error: 'Error'
        });
      }
    );
  };

  function request() {
    return { type: accountHomeViewConstants.SET_TARIFF_REQUEST };
  }
  function success(detail) {
    return { type: accountHomeViewConstants.SET_TARIFF_SUCCESS, detail };
  }
  function failure(error) {
    return { type: accountHomeViewConstants.SET_TARIFF_FAILURE, error };
  }
}
